import { useState } from "react";
import { Area, Point } from "react-easy-crop";
import { useTheme } from "styled-components";

import { API_CALLS } from "../../../../../API/api_calls";
import { Divider } from "../../../../../commonStyles";
import { Modal } from "../../../../Common";
import CropImageModalProps from "./CropImageModal";
import ModalBody from "./modalBody";
import ModalFooter from "./ModalFooter";
import ModalHeader from "./ModalHeader";
import getCroppedImg from "./utils";
import { useAppSelector } from "../../../../../redux";
import { ArticleProps } from "../../../../../redux/slices/article/Article";

const CropImageModal = ({
  imageUrl,
  setIsCropModalOpen,
  onImageUpload,
}: CropImageModalProps.IProps) => {
  const { Color } = useTheme();
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState({} as Area);
  const [isCroppedView, setIsCroppedView] = useState(false);
  const [croppedImage, setCroppedImage] = useState<Blob | null>(null);
  const { post_id, content_id, content_type, row_config, article_order } =
    useAppSelector(
      (state) =>
        state.article.draftArticle.cover_image as ArticleProps.WithImageContent
    );

  const onCropComplete = (_: Area, croppedAreaPixels: Area) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const submitButtonClick = async () => {
    try {
      if (isCroppedView) {
        croppedImage &&
          API_CALLS.ARTICLE.createOrUpdateArticleContent({
            post_id,
            content_type,
            content_id,
            element_role: row_config.element_role,
            article_order,
            image: croppedImage,
          });
        setIsCropModalOpen(false);
      } else {
        const newCroppedImage = (await getCroppedImg(
          imageUrl,
          croppedAreaPixels,
          rotation
        )) as Blob;
        setCroppedImage(newCroppedImage);
        setIsCroppedView(true);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onCancelOrChangeImage = () => {
    setIsCropModalOpen(false);
    if (isCroppedView) {
      onImageUpload();
    }
  };
  return (
    <Modal from="crop-modal" type="Pages" zIndex={6} maxWidth={1130}>
      <ModalHeader setIsCropModalOpen={setIsCropModalOpen} />
      <Divider $color={Color.border["ui-border-subtle"].value} />
      <ModalBody
        imageUrl={imageUrl}
        onCropComplete={onCropComplete}
        crop={crop}
        setCrop={setCrop}
        zoom={zoom}
        setZoom={setZoom}
        rotation={rotation}
        setRotation={setRotation}
        isCroppedView={isCroppedView}
        croppedImage={croppedImage}
        setIsCroppedView={setIsCroppedView}
      />
      <Divider $color={Color.border["ui-border-subtle"].value} />
      <ModalFooter
        submitButtonClick={submitButtonClick}
        isCroppedView={isCroppedView}
        onCancelOrChangeImage={onCancelOrChangeImage}
      />
    </Modal>
  );
};

export default CropImageModal;
